import { render, staticRenderFns } from "./Extend.vue?vue&type=template&id=1cf26318&"
import script from "./Extend.vue?vue&type=script&lang=ts&"
export * from "./Extend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports